import { Divider, Box } from '@chakra-ui/react'
import { PointBackBanner, CampaignHeaderBanner } from '@!/components/Banner'
import { SearchForm } from '@!/Store/Common/containers'
import { HeaderInfo } from '@!/Store/FeatureList/components'
import { TitleList } from '@!/Store/FreeFeature/components/TitleList'

const FreeFeature = ({ freeFeature, campaign }) => {
  return (
    <>
      {campaign ? <CampaignHeaderBanner campaign={campaign} /> : <PointBackBanner />}
      <SearchForm />
      <Box px={4}>
        <HeaderInfo title={freeFeature.feature_name} />
        <Divider />
        {freeFeature.titles && <TitleList titles={freeFeature.titles} />}
      </Box>
    </>
  )
}

export default FreeFeature
